import _defineProperty from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Button/button';
import { css } from '@patternfly/react-styles';
import { Spinner, spinnerSize } from '../Spinner';
import { useOUIAProps } from '../../helpers';
import { Badge } from '../Badge';
export var ButtonVariant;
(function (ButtonVariant) {
  ButtonVariant["primary"] = "primary";
  ButtonVariant["secondary"] = "secondary";
  ButtonVariant["tertiary"] = "tertiary";
  ButtonVariant["danger"] = "danger";
  ButtonVariant["warning"] = "warning";
  ButtonVariant["link"] = "link";
  ButtonVariant["plain"] = "plain";
  ButtonVariant["control"] = "control";
})(ButtonVariant || (ButtonVariant = {}));
export var ButtonType;
(function (ButtonType) {
  ButtonType["button"] = "button";
  ButtonType["submit"] = "submit";
  ButtonType["reset"] = "reset";
})(ButtonType || (ButtonType = {}));
var ButtonBase = function ButtonBase(_a) {
  var _a$children = _a.children,
    children = _a$children === void 0 ? null : _a$children,
    _a$className = _a.className,
    className = _a$className === void 0 ? '' : _a$className,
    _a$component = _a.component,
    component = _a$component === void 0 ? 'button' : _a$component,
    _a$isActive = _a.isActive,
    isActive = _a$isActive === void 0 ? false : _a$isActive,
    _a$isBlock = _a.isBlock,
    isBlock = _a$isBlock === void 0 ? false : _a$isBlock,
    _a$isDisabled = _a.isDisabled,
    isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
    _a$isAriaDisabled = _a.isAriaDisabled,
    isAriaDisabled = _a$isAriaDisabled === void 0 ? false : _a$isAriaDisabled,
    _a$isLoading = _a.isLoading,
    isLoading = _a$isLoading === void 0 ? null : _a$isLoading,
    _a$isDanger = _a.isDanger,
    isDanger = _a$isDanger === void 0 ? false : _a$isDanger,
    spinnerAriaValueText = _a.spinnerAriaValueText,
    spinnerAriaLabelledBy = _a.spinnerAriaLabelledBy,
    spinnerAriaLabel = _a.spinnerAriaLabel,
    _a$isSmall = _a.isSmall,
    isSmall = _a$isSmall === void 0 ? false : _a$isSmall,
    _a$isLarge = _a.isLarge,
    isLarge = _a$isLarge === void 0 ? false : _a$isLarge,
    _a$inoperableEvents = _a.inoperableEvents,
    inoperableEvents = _a$inoperableEvents === void 0 ? ['onClick', 'onKeyPress'] : _a$inoperableEvents,
    _a$isInline = _a.isInline,
    isInline = _a$isInline === void 0 ? false : _a$isInline,
    _a$type = _a.type,
    type = _a$type === void 0 ? ButtonType.button : _a$type,
    _a$variant = _a.variant,
    variant = _a$variant === void 0 ? ButtonVariant.primary : _a$variant,
    _a$iconPosition = _a.iconPosition,
    iconPosition = _a$iconPosition === void 0 ? 'left' : _a$iconPosition,
    _a$ariaLabel = _a['aria-label'],
    ariaLabel = _a$ariaLabel === void 0 ? null : _a$ariaLabel,
    _a$icon = _a.icon,
    icon = _a$icon === void 0 ? null : _a$icon,
    ouiaId = _a.ouiaId,
    _a$ouiaSafe = _a.ouiaSafe,
    ouiaSafe = _a$ouiaSafe === void 0 ? true : _a$ouiaSafe,
    _a$tabIndex = _a.tabIndex,
    tabIndex = _a$tabIndex === void 0 ? null : _a$tabIndex,
    innerRef = _a.innerRef,
    countOptions = _a.countOptions,
    props = __rest(_a, ["children", "className", "component", "isActive", "isBlock", "isDisabled", "isAriaDisabled", "isLoading", "isDanger", "spinnerAriaValueText", "spinnerAriaLabelledBy", "spinnerAriaLabel", "isSmall", "isLarge", "inoperableEvents", "isInline", "type", "variant", "iconPosition", 'aria-label', "icon", "ouiaId", "ouiaSafe", "tabIndex", "innerRef", "countOptions"]);
  var ouiaProps = useOUIAProps(Button.displayName, ouiaId, ouiaSafe, variant);
  var Component = component;
  var isButtonElement = Component === 'button';
  var isInlineSpan = isInline && Component === 'span';
  var preventedEvents = inoperableEvents.reduce(function (handlers, eventToPrevent) {
    return Object.assign(Object.assign({}, handlers), _defineProperty({}, eventToPrevent, function (event) {
      event.preventDefault();
    }));
  }, {});
  var getDefaultTabIdx = function getDefaultTabIdx() {
    if (isDisabled) {
      return isButtonElement ? null : -1;
    } else if (isAriaDisabled) {
      return null;
    } else if (isInlineSpan) {
      return 0;
    }
  };
  return React.createElement(Component, Object.assign({}, props, isAriaDisabled ? preventedEvents : null, {
    "aria-disabled": isDisabled || isAriaDisabled,
    "aria-label": ariaLabel,
    className: css(styles.button, styles.modifiers[variant], isBlock && styles.modifiers.block, isDisabled && styles.modifiers.disabled, isAriaDisabled && styles.modifiers.ariaDisabled, isActive && styles.modifiers.active, isInline && variant === ButtonVariant.link && styles.modifiers.inline, isDanger && (variant === ButtonVariant.secondary || variant === ButtonVariant.link) && styles.modifiers.danger, isLoading !== null && children !== null && styles.modifiers.progress, isLoading && styles.modifiers.inProgress, isSmall && styles.modifiers.small, isLarge && styles.modifiers.displayLg, className),
    disabled: isButtonElement ? isDisabled : null,
    tabIndex: tabIndex !== null ? tabIndex : getDefaultTabIdx(),
    type: isButtonElement || isInlineSpan ? type : null,
    role: isInlineSpan ? 'button' : null,
    ref: innerRef
  }, ouiaProps), isLoading && React.createElement("span", {
    className: css(styles.buttonProgress)
  }, React.createElement(Spinner, {
    size: spinnerSize.md,
    isInline: isInline,
    "aria-valuetext": spinnerAriaValueText,
    "aria-label": spinnerAriaLabel,
    "aria-labelledby": spinnerAriaLabelledBy
  })), variant === ButtonVariant.plain && children === null && icon ? icon : null, variant !== ButtonVariant.plain && icon && iconPosition === 'left' && React.createElement("span", {
    className: css(styles.buttonIcon, styles.modifiers.start)
  }, icon), children, variant !== ButtonVariant.plain && icon && iconPosition === 'right' && React.createElement("span", {
    className: css(styles.buttonIcon, styles.modifiers.end)
  }, icon), countOptions && React.createElement("span", {
    className: css(styles.buttonCount, countOptions.className)
  }, React.createElement(Badge, {
    isRead: countOptions.isRead
  }, countOptions.count)));
};
export var Button = React.forwardRef(function (props, ref) {
  return React.createElement(ButtonBase, Object.assign({
    innerRef: ref
  }, props));
});
Button.displayName = 'Button';